import { _get } from "./Axios";

export default class KoasApi {
    static get(id = null) {
        if (id)
            return _get('/masterdata/koas/' + id)
        else
            return _get('/masterdata/koas')
    }

    static getSchedule() {
        return _get('/masterdata/dpjp/schedule')
    }
}